import {mapGetters} from "vuex"

export default {
  computed: {
    ...mapGetters('auth', ['groupPriceModel']),
  },
  methods: {
    /**
     * Checks if a price model feature is enabled.
     *
     * It returns false if it's disabled, the required method param isn't set or if the user doesn't have a group/price
     * model assigned.
     *
     * @param priceModelFeatureId - the feature id to check (required)
     * @returns {boolean|*} - true/false
     */
    isPriceModelFeatureEnabled(priceModelFeatureId) {
      if (priceModelFeatureId === null || priceModelFeatureId === undefined) {
        console.error("PriceModel mixin: Required param priceModelFeatureId is missing.")
        return false
      }
      if (this.groupPriceModel === null) {
        console.warn("PriceModel mixin: The user doesn't have a group/price model assigned")
        return false
      }

      if(this.groupPriceModel.id === 'DEVELOPER') {
        return true
      }

      const feature = this.groupPriceModel.permissions.find(f => f.feature.id === priceModelFeatureId)
      if (feature) {
        return feature.enabled
      }

      return false
    },
    /**
     * Returns the limit for the given feature id.
     *
     * If the internally called isPriceModelFeatureEnabled is returning false this method returns null.
     *
     * @param priceModelFeatureId - the feature id to check (required)
     * @returns {null|*} - the limit as number or null
     */
    priceModelEnabledAndLimit(priceModelFeatureId) {
      if (this.isPriceModelFeatureEnabled(priceModelFeatureId)) {
        if(this.groupPriceModel.id === 'DEVELOPER') {
          return 1000
        }
        const feature = this.groupPriceModel.permissions.find(f => f.feature.id === priceModelFeatureId)
        if (feature) {
          return feature.limited
        }
      }

      return null
    },
    /**
     * Returns the levels for the given feature id.
     *
     * If the internally called isPriceModelFeatureEnabled is returning false this method returns an empty array.
     *
     * @param priceModelFeatureId - the feature id to check (required)
     * @returns {Array} - the levels as array or an empty array
     */
    priceModelEnabledAndLevels(priceModelFeatureId) {
      if (this.isPriceModelFeatureEnabled(priceModelFeatureId)) {
        const feature = this.groupPriceModel.permissions.find(f => f.feature.id === priceModelFeatureId)
        if (feature) {
          return feature.levels
        }
      }

      return []
    },
    /**
     * Returns the description for the given feature id.
     *
     * @param priceModelFeatureId - the feature id to check (required)
     * @returns {string} - the description of the feature
     */
    priceModelDescription(priceModelFeatureId) {
      const feature = this.groupPriceModel.permissions.find(f => f.feature.id === priceModelFeatureId)
      return feature.feature.description
    }
  }
}
